import CommonService from '../services/common';

export default {
    namespaced: true,
    state: () => ({

    }),
    mutations: {
        setData(state, data){
            state[data.name] = data.values;
        }
    },
    actions: {
        async loadData({commit}, payload){
            commit('setData', {
                name: payload.name,
                values: []
            });
            await CommonService.loadGeneric(payload.api, payload.params, response => {
                if(response.success){
                    let data = {
                        name: payload.name,
                        values: response.data
                    };
                    commit('setData', data);
                }
            })
        }
    }

}